module.exports = __webpack_public_path__ + "static/media/navBar-project.fa91695f.svg";